(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[180],{

/***/ "Itgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ECBadge; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var ECBadge = function ECBadge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE : _ref$color,
      size = _ref.size;
  return __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    alt: alt,
    className: className,
    color: color,
    dataTestid: "ECBadge",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].EXCLUSIVE_COLLECTION,
    width: size
  });
};

/***/ }),

/***/ "eiEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ECBadge.jsx
var ECBadge = __webpack_require__("Itgl");

// CONCATENATED MODULE: ./src/client/components/widgets/exclusive-collection-space-introduction/ExclusiveCollectionSpaceIntroduction.jsx



var __jsx = react_default.a.createElement;












var ExclusiveCollectionSpaceIntroduction_ExclusiveCollectionSpaceIntroduction = function ExclusiveCollectionSpaceIntroduction(_ref) {
  var imageSrc = _ref.imageSrc,
      link = _ref.link,
      text = _ref.text,
      title = _ref.title;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])();
  var router = Object(next_router["useRouter"])();

  if (!title) {
    return null;
  }

  var image = __jsx(Image["a" /* Image */], {
    className: "w-full",
    imageUrl: imageSrc,
    ratioKey: ratios_utils["c" /* default */].XL
  });

  var wrappedImage = link ? __jsx(DynamicLink["a" /* default */], {
    url: link.url
  }, image) : image;
  return __jsx("article", {
    className: classnames_default()('h-full isolate flex sm:items-center sm:min-h-[30rem] overflow-hidden relative rounded-12', {
      'bg-ultramarine ': !isTablet,
      'bg-white': isTablet
    }),
    "data-testid": "global-ec-component"
  }, __jsx("div", {
    className: "relative sm:static sm:h-full w-full"
  }, isTablet && __jsx("div", {
    className: "absolute bg-ultramarine start-0 inset-y-0 pointer-events-none rounded-12",
    style: {
      width: 'calc(700 / 1180 * 100%)'
    }
  }), __jsx("div", {
    className: "flex h-full items-center mx-auto relative text-white sm:w-5/6"
  }, __jsx("div", {
    className: "p-15 sm:py-20 sm:px-0 w-full"
  }, __jsx(ECBadge["a" /* ECBadge */], {
    className: "!block mx-auto my-20 sm:mx-0 sm:mt-0 sm:mb-20 opacity-50",
    size: "7.1875rem"
  }), !isTablet && __jsx(react["Fragment"], null, __jsx("div", {
    className: "w-1 bg-white py-10 mx-auto"
  }), __jsx("div", {
    className: "w-1 bg-ultramarine py-10 mx-auto absolute bottom-0 inset-x-0"
  }), __jsx("div", {
    className: "overflow-hidden mx-auto relative rounded-12 shrink-0",
    style: {
      maxWidth: '380px'
    }
  }, wrappedImage)), __jsx("div", {
    className: classnames_default()('leading-tight', {
      'bg-white -m-15 -mt-20 p-15 pt-20 text-black': !isTablet
    })
  }, __jsx(Title["a" /* Title */], {
    className: "font-bold font-brand mb-10 pt-20 text-18 sm:text-24 sm:text-white",
    hLevel: 3,
    theme: "none"
  }, __jsx("div", {
    className: "h-1 bg-white absolute end-full me-20 mt-15",
    style: {
      width: 'calc(120rem / 16)'
    }
  }), __jsx("div", {
    className: "h-1 bg-ultramarine absolute start-full ms-20 mt-15",
    style: {
      width: 'calc(120rem / 16)'
    }
  }), title), __jsx(Text["a" /* Text */], {
    className: "font-sans text-14 sm:p-0 sm:pe-10 sm:me-auto sm:text-white",
    text: text,
    theme: "none"
  }), (link === null || link === void 0 ? void 0 : link.url) && __jsx("button", {
    type: "button",
    className: classnames_default()('block mt-20 text-14 underline', {
      'text-black mb-20': !isTablet,
      'text-white': isTablet
    }),
    "data-testid": "ec-see-more-tab",
    onClick: function onClick() {
      track({
        actionGA: 'exclusiveCollection',
        labelGA: 'seeMore'
      });
      var newUrlWithTab = new URI_default.a(router.asPath).hash(link.url).toString();
      router.push(newUrlWithTab);
    }
  }, link.text))), isTablet && __jsx("div", {
    className: "overflow-hidden ms-20 relative rounded-12 shrink-0 w-3/5"
  }, wrappedImage))));
};
// CONCATENATED MODULE: ./src/client/components/lines/exclusive-collection-space-introduction-line/ExclusiveCollectionSpaceIntroductionLine.jsx


var ExclusiveCollectionSpaceIntroductionLine_jsx = react_default.a.createElement;




var ExclusiveCollectionSpaceIntroductionLine_ExclusiveCollectionSpaceIntroductionLine = function ExclusiveCollectionSpaceIntroductionLine(_ref) {
  var id = _ref.id,
      exclusiveCollectionIntroduction = _ref.resort.exclusiveCollectionIntroduction,
      seeMoreTargetAnchor = _ref.seeMoreTargetAnchor;

  if (!exclusiveCollectionIntroduction) {
    return null;
  }

  var _exclusiveCollectionI = exclusiveCollectionIntroduction.global,
      _exclusiveCollectionI2 = _exclusiveCollectionI.description,
      description = _exclusiveCollectionI2 === void 0 ? '' : _exclusiveCollectionI2,
      _exclusiveCollectionI3 = _exclusiveCollectionI.images,
      images = _exclusiveCollectionI3 === void 0 ? [] : _exclusiveCollectionI3,
      _exclusiveCollectionI4 = _exclusiveCollectionI.shortDescription,
      shortDescription = _exclusiveCollectionI4 === void 0 ? '' : _exclusiveCollectionI4;
  return ExclusiveCollectionSpaceIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ExclusiveCollectionSpaceIntroductionLine_jsx(ExclusiveCollectionSpaceIntroduction_ExclusiveCollectionSpaceIntroduction, {
    imageSrc: images.length > 0 ? images[0] : '',
    link: {
      text: Object(i18n["h" /* t */])('common.seeMore'),
      url: "#".concat(seeMoreTargetAnchor)
    },
    text: description,
    title: shortDescription
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/exclusive-collection-space-introduction/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ExclusiveCollectionSpaceIntroductionLine_ExclusiveCollectionSpaceIntroductionLine);

/***/ })

}]);